export default __webpack_public_path__ + "static/media/logout.9d5467f2.svg";